import { AiOutlineEye } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { type Merchant } from '../../../common/types';

interface IProps {
  merchants: Merchant[];
}

const RecentMerchants: React.FC<IProps> = ({ merchants }) => {
  return (
    <div className="w-full p-2 my-2 overflow-auto flex flex-col space-y-2 border-b-gray-50">
      {merchants.map((merchant) => {
        return (
          <div
            key={`recent-merchant-${merchant.id}`}
            className="w-full bg-gray-50 p-4 flex justify-between justify-items-center items-center rounded-md"
          >
            <span>{merchant.name}</span>
            <span>
              <Link to={`/admin/merchants/${merchant.id}`}>
                <AiOutlineEye size={20} />
              </Link>
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default RecentMerchants;
